import React from 'react';
import { Button } from './ui/button';
import { Heart, ArrowRight } from 'lucide-react';

const Donation = () => {
  return (
    <section id="donate" className="relative py-20 md:py-32 overflow-hidden">
      {/* Enhanced Purple Background with Depth */}
      <div className="absolute inset-0 bg-gradient-to-br from-purple-700 via-purple-800 to-purple-900"></div>
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSI+PHBhdGggZD0iTTM2IDE0YzAtMi4yMDktMS43OTEtNC00LTRzLTQgMS43OTEtNCA0IDEuNzkxIDQgNCA0IDQtMS43OTEgNC00em0wIDI4YzAtMi4yMDktMS43OTEtNC00LTRzLTQgMS43OTEtNCA0IDEuNzkxIDQgNCA0IDQtMS43OTEgNC00ek0xNCAyOGMtMi4yMDkgMC00IDEuNzkxLTQgNHMxLjc5MSA0IDQgNCA0LTEuNzkxIDQtNC0xLjc5MS00LTQtNHptMjggMGMtMi4yMDkgMC00IDEuNzkxLTQgNHMxLjc5MSA0IDQgNCA0LTEuNzkxIDQtNC0xLjc5MS00LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-30"></div>
      <div className="absolute inset-0 opacity-20" style={{
        backgroundImage: `radial-gradient(circle at 20% 30%, rgba(167, 139, 250, 0.3) 0%, transparent 50%),
                         radial-gradient(circle at 80% 70%, rgba(139, 92, 246, 0.25) 0%, transparent 50%)`
      }}></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-8">
            <Heart className="w-10 h-10 text-white fill-white" />
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            Invest in Kissimmee's Future
          </h2>
          
          <p className="text-xl md:text-2xl text-white/95 mb-8 leading-relaxed max-w-3xl mx-auto">
            Your contribution is an investment in the future of Kissimmee. Together, we can build a community of opportunity, safety, and progress for all.
          </p>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 mb-8 border border-white/20 shadow-2xl">
            <p className="text-white text-lg mb-6">
              Every donation, no matter the size, helps us reach more voters and share our vision for a better Kissimmee.
            </p>
            <a
              href="https://square.link/u/PPzV8yyu"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-purple-900 font-bold text-xl px-12 py-7 rounded-lg shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105 group"
            >
              Donate Now
              <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          <p className="text-white/80 text-sm italic">
            Political contributions are not tax-deductible. Paid for and approved by Wanda Roman for City of Kissimmee Commissioner Seat 2.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Donation;
